import axios from "axios";
import { logoutUser } from "./utils/authUtils";

let globalNavigate: ((path: string) => void) | null = null;

export function setGlobalNavigate(fn: (path: string) => void) {
    globalNavigate = fn;
}

const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    headers: { "Content-Type": "application/json" },
});

// Token renewal + auto logout
api.interceptors.response.use(
    (res) => {
        const newToken = res.headers['x-new-jwt'];
        if (newToken) {
            localStorage.setItem("token", newToken);
        }
        return res;
    },
    (err) => {
        if (err.response?.status === 401 && globalNavigate) {
            logoutUser(globalNavigate);
        }
        return Promise.reject(err);
    }
);

export default api;

export const extractErrorMessage = (error: any): string => {
    if (error?.response) {
        const { status, statusText, data } = error.response;

        // ASP.NET ModelState errors
        //if (data?.errors) {
        //    const allErrors = Object.entries(data.errors)
        //        .map(([field, messages]) => {
        //            const msg = Array.isArray(messages) ? messages.join(", ") : messages;
        //            return `${field}: ${msg}`;
        //        })
        //        .join("\n");

        //    return `Validation error (${status}):\n${allErrors}`;
        //}

        // Backend-provided message
        //if (data?.message) return `${data.message} (${status})`;
        // Your backend custom validation format: { message: "...", errors: [ { field, errors[] } ] }
        if (Array.isArray(data?.errors)) {
            const formatted = data.errors
                .map((e: any) => {
                    const field = cleanFieldName(e.field);
                    const msgs = Array.isArray(e.errors) ? e.errors.join(", ") : e.errors;
                    return `${field}: ${msgs}`;
                })
                .join("\n");

            return `${data.message || "Validation error"}:\n${formatted}`;
        }

        // ASP.NET problem details
        if (data?.title) return `${data.title} (${status})`;

        // Fallback
        return `Request failed (${status} ${statusText})\n${JSON.stringify(data)}`;
    }

    if (error?.message) return error.message;

    return "Unknown error occurred while saving.";
};

const cleanFieldName = (field: string) => {
    if (!field) return "Field";

    let f = field.replace("$.", ""); // remove $.

    // Convert "orderServices[1].serviceId" → "Service #2 → serviceId"
    f = f.replace(/orderServices\[(\d+)\]\.(.*)/, (_, index, prop) => {
        return `Service #${Number(index) + 1} → ${prop}`;
    });

    return f;
};
